import type { Filter } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { ChipBehaviour, FilterTypeBehaviour } from '@/app/common/filters/types/filterTypeDefinition.ts';
import { switchType } from '@/app/common/filters/types/switch/switchType.ts';
import { multiSelectType } from '@/app/common/filters/types/multiSelect/multiSelectType.ts';
import { radioType } from '@/app/common/filters/types/radio/radioType.ts';
import { rangeType } from '@/app/common/filters/types/range/rangeType.ts';
import { searchType } from '@/app/common/filters/types/search/searchType.ts';
import { searchDynamicType } from '@/app/common/filters/types/searchDynamic/searchDynamicType.ts';

export const FILTER_TYPE_BEHAVIOUR: Record<FILTER_TYPE, FilterTypeBehaviour> = {
  [FILTER_TYPE.SWITCH]: switchType,
  [FILTER_TYPE.MULTI_SELECT]: multiSelectType,
  [FILTER_TYPE.RADIO]: radioType,
  [FILTER_TYPE.RANGE]: rangeType,
  [FILTER_TYPE.SEARCH]: searchType,
  [FILTER_TYPE.SEARCH_DYNAMIC]: searchDynamicType,
};

export const filterTypeOf = (filter: Filter): FilterTypeBehaviour => FILTER_TYPE_BEHAVIOUR[filter.type];

export const chipBehaviourOf = (filter: Filter): ChipBehaviour | undefined => filterTypeOf(filter).chips;
